// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_uSd","cls2":"ActiveState-cls2_bR1 ActiveState-cls1_uSd","isSingleDisabled":"ActiveState-isSingleDisabled_q3i"};